import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared';
import { ClienteCongelamentoCardInfoComponent } from './card-info';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteCongelamentoCardInfoComponent
    ],
    exports: [
        ClienteCongelamentoCardInfoComponent
    ]
})
export class ClienteCongelamentoCardInfoModule { }
